var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c("div", { staticClass: "card-container dflex" }, [
        _vm.shouldShowCreditCard
          ? _c("div", [
              _c("h4", [
                _vm._v(_vm._s(_vm.$l10n.__("Votre carte de paiement")))
              ]),
              _vm._v(" "),
              _vm.cardValidationInProgress
                ? _c(
                    "div",
                    [
                      _c("credit-card-template", {
                        attrs: {
                          validationInProgress: _vm.cardValidationInProgress,
                          validationMessage: _vm.$t.__(
                            "common.labels.card_being_validated"
                          ),
                          placeholder: _vm.$t.__("common.labels.no_card_saved")
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("credit-card-template", {
                        attrs: { creditcard: _vm.customerCreditCard }
                      })
                    ],
                    1
                  )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c("h4", { staticClass: "mb-5" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Ajouter une carte de paiement")))
          ]),
          _vm._v(" "),
          _vm.shouldShowCreditCard
            ? _c("p", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__("Ou définir une nouvelle carte de paiement")
                    ) +
                    "\n            "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "50px" } },
            [
              _c(
                "el-form",
                {
                  ref: "stripeForm",
                  attrs: {
                    "label-position": "top",
                    inline: false,
                    "inline-message": true,
                    model: _vm.stripeForm
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__("common.labels.credit_card"),
                        prop: "creditcard"
                      }
                    },
                    [_c("div", { attrs: { id: "creditcard" } })]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.get("card-number")
            ? _c("span", { staticClass: "red error" }, [
                _vm._v(_vm._s(_vm.errors.get("card-number"))),
                _c("br")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.errors.get("card-expiry")
            ? _c("span", { staticClass: "red error" }, [
                _vm._v(_vm._s(_vm.errors.get("card-expiry"))),
                _c("br")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.errors.get("card-cvc")
            ? _c("span", { staticClass: "red error" }, [
                _vm._v(_vm._s(_vm.errors.get("card-cvc"))),
                _c("br")
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }